import { render, staticRenderFns } from "./TqWriteReview.vue?vue&type=template&id=4ad77d4b&scoped=true&"
import script from "./TqWriteReview.vue?vue&type=script&lang=js&"
export * from "./TqWriteReview.vue?vue&type=script&lang=js&"
import style0 from "./TqWriteReview.vue?vue&type=style&index=0&id=4ad77d4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad77d4b",
  null
  
)

export default component.exports